import axios from 'axios';

import { getToken, setToken, signOut } from '~/modules/token';

// One configured axios instance for every request: the RTK Query base query and the
// few imperative calls (login sequence, blob download) share it, so auth rotation and
// the 401 redirect (`signOut`) live in exactly one place.
axios.interceptors.request.use(
  (config) => {
    const bayToken = getToken();

    if (bayToken) config.headers.Authorization = `Bearer ${bayToken}`;

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.meta && response.data.meta.bayToken) {
      setToken(response.data.meta.bayToken);
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) signOut();

    return Promise.reject(error);
  },
);

export { axios };
